import ShopNav from '@/components/ShopNav'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: ShopNav
	}

	let page = vuewidget(dom, options)
	return page
}
